import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MyPromise } from '../interceptors/myPromise.service';

const MEETINGSAPIURL = `${environment.baseEndpoint}/meetings`;

@Injectable({
  providedIn: 'root',
})
export class MeetingsService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  getMeetings(stationId) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.get(`${MEETINGSAPIURL}/${stationId}`));
  }

  storeMeeting(stationId, meeting) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.post(`${MEETINGSAPIURL}/${stationId}`, meeting));
  }

  updateMeeting(stationId, meeting, meetingId) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.put(`${MEETINGSAPIURL}/${stationId}/${meetingId}`, meeting));
  }

  deleteMeeting(stationId, meetingId) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.delete(`${MEETINGSAPIURL}/${stationId}/${meetingId}`));
  }
}
